<template>
  <div class="main-wrap" id="SubmitReturnsExchange">
    <div style="padding: 16px 24px 0;">
      <div class="order-code">{{ $lang('原始运单号') }}：{{ form.waybillId }}</div>
    </div>
    <div class="page-container" v-loading="isLoadingPage">
      <el-form class="el-form-edit" ref="sizeForm" :rules="rules" :inline="true" :model="form" label-position="left" label-suffix=":" label-width="80px">
        <el-row :gutter="24">
          <el-col :span="12">
            <h3>{{ $lang('寄件人信息') }}</h3>
            <div class="group-container">
              <el-form-item :label="$lang('姓名')" prop="senderName">
                <el-autocomplete :maxlength="30"
                                 valueKey="name"
                                 v-model="form.senderName"
                                 @select="onChangeSenderName"
                                 :fetch-suggestions="remoteSenderName"
                                 :placeholder="$lang('请输入寄件人姓名')">
                  <template slot="suffix">
                    <i class="iconfont icondizhibao pointer" @click="openAddress(1)"></i>
                  </template>
                </el-autocomplete>
              </el-form-item>
              <el-form-item :label="$lang('手机')" prop="senderMobilePhone" class="formPhone">
                <BasePhoneInput v-model="form.senderMobilePhone" :maxlength="16"/>
              </el-form-item>
              <el-form-item :label="$lang('公司')" prop="senderCompany">
                <el-input v-model.trim="form.senderCompany" :minlength="1" :maxlength="50" :placeholder="$lang('请输入公司')"/>
              </el-form-item>
              <el-form-item :label="$lang('邮编')">
                <el-input v-model.trim="form.senderPostalCode" :minlength="1" :maxlength="10"/>
              </el-form-item>
              <el-form-item :label="$lang('邮箱')">
                <el-input v-model.trim="form.senderEmail" :minlength="1" :maxlength="30"/>
              </el-form-item>
              <el-form-item :label="senderProvinceName" prop="senderProvinceId">
                <el-select v-model="form.senderProvinceId" filterable>
                  <el-option v-for="item in provinceArray"
                             :key="item.id"
                             :label="item.nativeName"
                             :value="item.id"/>
                </el-select>
              </el-form-item>
              <el-form-item :label="senderCityName" prop="senderCityId">
                <el-select v-model="form.senderCityId" filterable @change="onCityChange($event,1)">
                  <el-option v-for="item in cityList"
                             :key="item.id"
                             :label="item.nativeName"
                             :value="item.id"/>
                </el-select>
              </el-form-item>
              <el-form-item :label="$lang('寄件区域')" prop="senderAreaName" v-if="countryId === 1">
                <el-select v-model="form.senderAreaId" filterable @change="onAreaChange($event,1)">
                  <el-option v-for="item in areaList"
                             :key="item.id"
                             :label="item.nativeName"
                             :value="item.id"/>
                </el-select>
              </el-form-item>
              <el-form-item :label="$lang('寄件街道')" prop="senderStreet">
                <el-input v-model="form.senderStreet" :placeholder="$lang('请输入寄件街道')" :minlength="1" :maxlength="20"/>
              </el-form-item>

              <el-form-item v-if="countryId === 1" :label="$lang('寄件短地址')" prop="senderShortAddress">
                <template slot="label"><span :title="$lang('寄件短地址')">{{ $lang('寄件短地址') }}</span></template>
                <el-input v-model="form.senderShortAddress" :placeholder="$lang('请输入寄件短地址')" :minlength="1" :maxlength="8" @blur="judgeShortAddress($event, 'senderShortAddressParseResults', 'senderShortAddress')" />
              </el-form-item>
              <el-form-item v-if="countryId === 1" :label="$lang('寄件建筑物编号')" prop="senderBuildingNumber">
                <template slot="label"><span :title="$lang('寄件建筑物编号')">{{ $lang('寄件建筑物编号') }}</span></template>
                <el-input v-model="form.senderBuildingNumber" :placeholder="$lang('请输入寄件建筑物编号')" :minlength="1" :maxlength="20"/>
              </el-form-item>
              <el-form-item v-if="countryId === 1" :label="$lang('寄件辅助编号')" prop="senderReferenceNumber">
                <template slot="label"><span :title="$lang('寄件辅助编号')">{{ $lang('寄件辅助编号') }}</span></template>
                <el-input v-model="form.senderReferenceNumber" :placeholder="$lang('请输入寄件辅助编号')" :minlength="1" :maxlength="20"/>
              </el-form-item>
              <el-form-item :label="$lang('详细地址')" prop="senderDetailedAddress" class="form-address" style="width: 100%;">
                <el-input v-model="form.senderDetailedAddress" :placeholder="$lang('请填写寄件人所在街道以及详细地址')" :minlength="1" :maxlength="200" style="margin-right: 15px;"/>
                <el-checkbox v-model="checkSenderFlag">{{ $lang('保存至地址簿') }}</el-checkbox>
              </el-form-item>

            </div>
          </el-col>
          <el-col :span="12">
            <h3>{{ $lang('收件人信息') }}</h3>
            <div class="group-container">
              <el-form-item :label="$lang('姓名')" prop="receiverName">
                <el-autocomplete :maxlength="30"
                                 valueKey="name"
                                 v-model="form.receiverName"
                                 @select="onChangeReceiverName"
                                 :fetch-suggestions="remoteReceiverName"
                                 :placeholder="$lang('请输入收件人姓名')">
                  <template slot="suffix">
                    <i class="iconfont icondizhibao pointer" @click="openAddress(2)"></i>
                  </template>
                </el-autocomplete>
              </el-form-item>
              <el-form-item :label="$lang('手机')" prop="receiverMobilePhone">
                <BasePhoneInput v-model="form.receiverMobilePhone" :maxlength="16"/>
              </el-form-item>
              <el-form-item :label="$lang('备用号码')" prop="receiverTelphone">
                <BasePhoneInput v-model="form.receiverTelphone" :maxlength="16"/>
              </el-form-item>
              <el-form-item :label="$lang('公司')" prop="receiverCompany">
                <el-input v-model="form.receiverCompany" :placeholder="$lang('请输入公司')" :minlength="1" :maxlength="20"/>
              </el-form-item>
              <el-form-item :label="$lang('邮编')">
                <el-input v-model.trim="form.receiverPostalCode" :minlength="1" :maxlength="20"/>
              </el-form-item>
              <el-form-item :label="$lang('邮箱')">
                <el-input v-model.trim="form.receiverEmail" :minlength="1" :maxlength="30"/>
              </el-form-item>
              <el-form-item :label="receiverProvinceName" prop="receiverProvinceId">
                <el-select v-model="form.receiverProvinceId" filterable @change="onProvinceChange($event,2)">
                  <el-option v-for="item in provinceArray"
                             :key="item.id"
                             :label="item.nativeName"
                             :value="item.id"/>
                </el-select>
              </el-form-item>
              <el-form-item :label="receiverCityName" prop="receiverCityId">
                <el-select v-model="form.receiverCityId" filterable @change="onCityChange($event,2)">
                  <el-option v-for="item in cityList2"
                             :key="item.id"
                             :label="item.nativeName"
                             :value="item.id"/>
                </el-select>
              </el-form-item>
              <el-form-item :label="$lang('收件区域')" prop="receiverAreaId" v-if="countryId === 1">
                <el-select v-model="form.receiverAreaId" filterable @change="onAreaChange($event,2)">
                  <el-option v-for="item in areaList2"
                             :key="item.id"
                             :label="item.nativeName"
                             :value="item.id"/>
                </el-select>
              </el-form-item>
              <el-form-item :label="$lang('收件街道')" prop="receiverStreet">
                <el-input v-model="form.receiverStreet" :placeholder="$lang('请输入收件街道')" :minlength="1" :maxlength="20"/>
              </el-form-item>
              <el-form-item v-if="countryId === 1" :label="$lang('收件短地址')" prop="receiverShortAddress">
                <template slot="label"><span :title="$lang('收件短地址')">{{ $lang('收件短地址') }}</span></template>
                <el-input v-model="form.receiverShortAddress" :placeholder="$lang('请输入收件短地址')" :minlength="1" :maxlength="8" @blur="judgeShortAddress($event, 'receiverShortAddressParseResults', 'receiverShortAddress')" />
              </el-form-item>
              <el-form-item v-if="countryId === 1" :label="$lang('收件建筑物编号')" prop="receiverBuildingNumber">
                <template slot="label"><span :title="$lang('收件建筑物编号')">{{ $lang('收件建筑物编号') }}</span></template>
                <el-input v-model="form.receiverBuildingNumber" :placeholder="$lang('请输入收件建筑物编号')" :minlength="1" :maxlength="20"/>
              </el-form-item>
              <el-form-item v-if="countryId === 1" :label="$lang('收件辅助编号')" prop="receiverReferenceNumber">
                <template slot="label"><span :title="$lang('收件辅助编号')">{{ $lang('收件辅助编号') }}</span></template>
                <el-input v-model="form.receiverReferenceNumber" :placeholder="$lang('请输入收件辅助编号')" :minlength="1" :maxlength="20"/>
              </el-form-item>
              <el-form-item :label="$lang('详细地址')" prop="receiverDetailedAddress" class="form-address">
                <el-input v-model="form.receiverDetailedAddress" :placeholder="$lang('请填写收件人所在街道以及详细地址')" :minlength="1" :maxlength="200" style="margin-right: 15px;"/>
                <el-checkbox v-model="form.checkReceiverFlag">{{ $lang('保存至地址簿') }}</el-checkbox>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <h3>{{ $lang('货物信息') }}</h3>
            <div class="group-container">
              <el-form-item :label="$lang('件数')" prop="packageNumber">
                <el-input-number v-model="form.packageNumber" :label="$lang('描述文字')" step-strictly :min="1" :max="999"/>
              </el-form-item>

              <el-form-item :label="$lang('物品类型')" prop="goods" ref="goods">
                <base-select v-model="form.goods"
                             :props="{label:'name',value:'code', res:'appArticleTypeVOList',valueObj:true}"
                             dicUrl="/vip/baseData/list" :placeholder="$lang('请选择')"/>
              </el-form-item>

              <el-form-item :label="$lang('物品名称')" prop="goodsName">
                <el-input v-model="form.goodsName" :placeholder="$lang('请输入')" :minlength="1" :maxlength="100"/>
              </el-form-item>

              <el-form-item :label="$lang('物品重量(kg)')" prop="packageTotalWeight">
                <el-input-number v-model="form.packageTotalWeight" :label="$lang('描述文字')" :precision="2" :min="0" :max="99999.99"/>
              </el-form-item>

              <el-form-item :label="$lang('结算方式')" prop="payment">
                <base-select v-model="form.payment"
                             :disabled="true"
                             :props="{label:'name',value:'code', res:'appPaymentMannerVOList',valueObj:true}"
                             dicUrl="/vip/baseData/list" :placeholder="$lang('请选择')"/>
              </el-form-item>

              <el-form-item :label="$lang('支付方式')" prop="paidMode">
                <base-select v-model="form.paidMode"
                             :props="{label:'name',value:'code', res:'appPayTypeVOList',valueObj: true}"
                             :disabled="paidOption"
                             dicUrl="/vip/baseData/list" :placeholder="$lang('请选择')"/>
              </el-form-item>

              <el-form-item :label="$lang('退换货类型')" prop="expressTypeName">
                <el-input v-model="form.expressTypeName" disabled/>
              </el-form-item>

              <el-form-item :label="$lang('参考运费')" prop="standardValue">
                <el-input v-model="form.standardValue" :placeholder="$lang('请输入')" :disabled="true"/>
              </el-form-item>

              <el-form-item :label="$lang('客户订单号')" prop="customerOrderId">
                <el-input v-model="form.customerOrderId" :placeholder="$lang('请输入')" :minlength="1" :maxlength="50"/>
              </el-form-item>

              <el-form-item :label="$lang('平台')" prop="platformName">
                <el-input v-model.trim="form.platformName" :placeholder="$lang('请输入电商平台名称')" :minlength="1" :maxlength="10"/>
              </el-form-item>

              <el-form-item :label="$lang('客户账号')" prop="customerAccount">
                <el-input v-model.trim="form.customerAccount" :placeholder="$lang('请输入电商平台客户账号')" :minlength="1" :maxlength="10"/>
              </el-form-item>

              <el-form-item>
                <div slot="label"></div>
                <el-checkbox v-model="codFlag" @change="checkCod" :disabled="isReverse">{{ $lang('是否代收货款') }}</el-checkbox>
              </el-form-item>

              <el-form-item :label="$lang('代收货款币别')" prop="codCurrencyTypeName">
                <el-select v-model="form.codCurrencyTypeName" :disabled="codIsInput">
                  <el-option v-for="item in codCurrencyType" :key="item.codCurrencyTypeCode" :label="item.codCurrencyTypeName" :value="item.codCurrencyTypeCode"/>
                </el-select>
              </el-form-item>

              <el-form-item :label="$lang('代收货款金额')" prop="codMoney">
                <el-input v-model="form.codMoney" :label="$lang('描述文字')" :disabled="codIsInput" :placeholder="$lang('请输入对应的金额')" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
              </el-form-item>

              <el-form-item :label="$lang('代收货款手续费')" prop="codFee">
                <el-input v-model="form.codFee" :placeholder="$lang('请输入')" :minlength="1" :maxlength="12" :disabled="true"></el-input>
              </el-form-item>

              <el-form-item style="width: auto;margin-top: 20px;" prop="isUnpackEnabled">
                <el-switch v-model="form.isUnpackEnabled" :active-text="$lang('是否允许客户开箱验视')"/>
              </el-form-item>

              <el-form-item :label="$lang('是否购买赔偿上限服务')" prop="insured" class="insured-info">
                <base-select :clearable="false" v-model="form.insured" :dic="insuredDic" :disabled="form.goodsTypeName === '文件' || form.paymentModeName === 'PP_PM' " :placeholder="$lang('请选择')"
                             @change="changeInsured" :props="{label:'name' ,value:'code'}"></base-select>
              </el-form-item>

              <el-form-item :label="$lang('货物价值')" prop="declaredValue" v-show="form.insured === 1" class="declaredValue">
                <el-input-number v-model="form.declaredValue" :placeholder="$lang('请输入')" :step="1" :precision="0" :controls="false" :min="0" :max="99999"></el-input-number>
              </el-form-item>

              <el-form-item :label="$lang('赔偿上限服务费')" prop="insuredValue" v-show="form.insured===1">
                <el-input v-model="form.insuredValue" :placeholder="$lang('请输入')" :disabled="true"></el-input>
              </el-form-item>

              <el-form-item :label="$lang('商品图片')" style="width: 100%">
                <the-upload-image :upload-url="COM_HTTP.fetchUploadImage"
                                  :uploadData="uploadData"
                                  :list="imageList"
                                  :limit="10"
                                  @uploadSuccess="uploadSuccess"
                                  @uploadRemove="uploadRemove"/>
              </el-form-item>

              <el-form-item :label="$lang('商品描述')" prop="productDescription" style="width: 100%">
                <el-input v-model="form.productDescription" type="textarea" :rows="4" show-word-limit :maxlength="1000" resize="none" :placeholder="$lang('请输入')" style="width: 50%;"/>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div style="margin: 20px 0; text-align: center;">
        <el-button type="primary" @click="saveSubmitValidate('sizeForm')" :loading="isSubmitLoading" class="h48">{{ returnExchangeType === 1 ? $lang('立即下单') : $lang('确定') }}</el-button>
      </div>
    </div>

    <address-book v-model="addrBook" :selectType="selectType" @single-row-select="singleRowSelect" ref="address"/>
  </div>
</template>

<script>
import { checkAddressFormat, checkGoodsName, integerWeight, isNull, phoneAndMobile, RULES } from '@/utils/rules'
import { RESPONSE_SUCCESS } from '@/constants'
import {
  customerCod,
  fetchCreateReturnOrder,
  fetchExchangeDetail,
  fetchUploadImage,
  getCalc,
  getComCost,
  getComputationCost,
  getDefaultAddress,
  getList,
  getSettlement, getShortAddress,
  getsysCurrencyType, judgeShortAddress,
  reqAddressList
} from '@/api/module/customer'
import { GET_AREA, GET_AREANEW } from '@/api/base/public'
import { mapActions, mapGetters } from 'vuex'
import BaseSelect from '@/components/base/BaseSelect'
import BasePhoneInput from '@/components/base/BasePhoneInput'
import TheUploadImage from '@/views/return-exchange/components/TheUploadImage'
import AddressBook from '@/views/place-order/single-order/AddressBook'
import { waybillPlaintext } from '@api/base/public'

export default {
  name: 'SubmitReturns',
  components: { AddressBook, TheUploadImage, BasePhoneInput, BaseSelect },
  data() {
    return {
      COM_HTTP: { fetchUploadImage },
      // 退换货类型 1:退货; 2:换货
      returnExchangeType: 0,
      isLoadingPage: false,
      form: {
        senderName: '', // 寄件人姓名,
        senderMobilePhone: '', // 寄件人手机号,
        senderProvinceId: '', // 寄件省份id,
        senderProvinceName: '', // 寄件省份名称,
        senderCityId: '', // 寄件城市id,
        senderCityName: '', // 寄件城市名称,
        senderAreaId: '', // 寄件区域id,
        senderStreet: '', // 寄件区域名称,
        senderPostalCode: '', // 寄件邮编
        senderEmail: '', // 寄件邮箱
        senderProvince: '', // 寄件区省/市/区
        senderDetailedAddress: '', // 寄件详细地址,
        receiverName: '', // 收件人姓名,
        receiverMobilePhone: '', // 收件人手机号,
        receiverTelphone: '', // 收件人备用号码
        receiverProvinceId: '', // 收件省份id,
        receiverProvinceName: '', // 收件省份名称,
        receiverCityId: '', // 收件城市id,
        receiverCityName: '', // 收件城市名称,
        receiverAreaId: '', // 收件区域id,
        receiverStreet: '', // 收件区域名称,
        receiverPostalCode: '', // 收件邮编
        receiverEmail: '', // 收件邮箱
        receiverProvince: '', // 收件区省/市/区
        receiverDetailedAddress: '', // 收件详细地址,
        insured: 0, // 是否购买赔偿上限服务1是，0否,
        declaredValue: '', // 物品价值,
        insuredValue: 0, // 赔偿上限服务费,
        goods: '', // 物品类型
        goodsTypeId: '', // 物品类型id,
        goodsTypeCode: '', // 物品类型编码,
        goodsTypeName: '', // 物品类型名称,
        goodsName: '', // 物品名称,
        packageTotalWeight: 1, // 物品重量,
        packageNumber: 1, // 物品件数,
        payment: { code: 'PP_PM', name: this.$lang('Monthly'), id: 42 }, // 结算方式
        paidMode: {}, // 支付方式
        paidModeCode: '', // 支付方式code
        paidModeName: '', // 支付方式名称
        paidModeId: '', // 支付方式id
        paymentModeId: '42', // 结算方式id,
        paymentModeCode: 'PP_PM', // 结算方式编码,
        paymentModeName: this.$lang('Monthly'), // 结算方式名称,
        expressTypeCode: '', // 产品类型code
        expressTypeName: '', // 产品类型name
        codMoney: '', // 代收货款金额,
        codFee: 0, // COD手续费,
        standardValue: 0, // 参考运费,
        boxNumber: 0, // 箱材数量,
        boxStandard: '', // 箱材规格
        boxStandardId: '', // 箱材规格id,
        boxStandardCode: '', // 箱材规格编码,
        boxStandardName: '', // 箱材规格名称,
        boxPrice: 0, // 箱材单价,
        boxTotalPrice: 0, // 箱材总价,
        remarks: '', // 备注,
        settlementWeight: 0, // 结算重量
        packageChargeWeight: 1, // 结算重量
        customerOrderId: '', // 客户订单号
        senderCompany: '', // 寄件人公司
        receiverCompany: '', // 收件人公司
        checkSenderFlag: '', // 寄件人保存至地址簿
        checkReceiverFlag: '', // 寄件人保存至地址簿
        signReceipt: 0, // 签回单 0否 1是
        receiptFreight: 0, // 回单金额
        codCurrencyTypeName: '', // 代收货款币别
        codCurrencyTypeCode: '', // 代收货款币别code
        platformName: '', // 平台
        customerAccount: '', // 客户账号
        isUnpackEnabled: 0, // 是否允许客户开箱验视
        taxation: 0, // 税率
        returnType: 1, // 退换货类型
        originalWaybillId: '', // 源id
        productSkuImageUrl: '', // 商品图片
        productDescription: '', // 商品描述
        senderShortAddress: '',
        senderBuildingNumber: '',
        senderReferenceNumber: '',
        receiverShortAddress: '',
        receiverBuildingNumber: '',
        receiverReferenceNumber: ''
      },
      rules: {
        senderName: [RULES.required, { validator: isNull }],
        senderMobilePhone: [RULES.required, { validator: phoneAndMobile }],
        senderProvinceId: [RULES.requiredSelect],
        senderCityId: [RULES.requiredSelect],
        senderDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
        receiverName: [RULES.required, { validator: isNull }],
        receiverMobilePhone: [RULES.required, { validator: phoneAndMobile }],
        receiverTelphone: [{ validator: phoneAndMobile }],
        receiverProvinceId: [RULES.requiredSelect],
        receiverCityId: [RULES.requiredSelect],
        receiverDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
        goods: [RULES.required],
        goodsName: [RULES.required, { validator: checkGoodsName }],
        packageTotalWeight: [RULES.required, { validator: integerWeight }],
        payment: [RULES.requiredSelect],
        insured: [RULES.requiredSelect],
        isUnpackEnabled: [RULES.required],
        productDescription: [RULES.productDescription],
        senderShortAddress: [RULES.codeNumber],
        senderBuildingNumber: [RULES.twenty],
        senderReferenceNumber: [RULES.twenty],
        receiverShortAddress: [RULES.codeNumber],
        receiverBuildingNumber: [RULES.twenty],
        receiverReferenceNumber: [RULES.twenty]
      },
      senderProvinceName: this.$lang('省份'),
      senderCityName: this.$lang('寄件城市'),
      receiverProvinceName: this.$lang('省份'),
      receiverCityName: this.$lang('收件城市'),
      addrBook: false,
      codCurrencyType: [],
      receiptFreight: 0,
      checkReceiverFlag: false,
      codNumber: 3000, // 代收货款最大值
      initData: {
        url: '/oauth/sysRoleResource/getAppResources',
        type: 'app',
        leftText: this.$lang('未选权限'),
        rightText: this.$lang('已选权限'),
        rightOptText: this.$lang('全部权限'),
        exculdeIdsParam: 'resourceIds',
      },
      selectType: 1, // 地址薄类型
      sendAddressData: {
        formProps: {
          provinceIdProp: 'senderProvinceId',
          provinceNameProp: 'senderProvinceName',
          cityIdProp: 'senderCityId',
          cityNameProp: 'senderCityName',
        },
        defaultData: {},
      },
      receiverAddressData: {
        formProps: {
          provinceIdProp: 'receiverProvinceId',
          provinceNameProp: 'receiverProvinceName',
          cityIdProp: 'receiverCityId',
          cityNameProp: 'receiverCityName',
        },
        defaultData: {},
      },
      insuredDic: [
        { code: 0, label: this.$lang('否'), name: this.$lang('否') },
        { code: 1, label: this.$lang('是'), name: this.$lang('是') }
      ],
      signReceiptDic: [
        { code: 0, label: this.$lang('否'), name: this.$lang('否') },
        { code: 1, label: this.$lang('是'), name: this.$lang('是') }
      ],
      paidOption: false,
      cityList: [],
      cityList2: [],
      areaList: [],
      areaList2: [],
      provinceArray: [],
      checkSenderFlag: false,
      codIsInput: true,
      codFlag: false, // 是否代收货款
      // senderExpressTypeData: [], // 产品类型
      // receiverExpressTypeData: [],
      uploadData: {
        projectName: 'yl-jmssa-vip',
        moduleName: 'vip'
      },
      imageList: [],
      isSubmitLoading: false, // 提交数据加载
    }
  },
  created() {
    // 获取酋长国数据
    this.getProList()
    // 获取基础数据
    this.getBaseDataList()
    // 获取币别
    this.getCurrencyTypeList()
    console.log('SubmitReturns', this.$route)
    const { id, type } = this.$route.params
    console.log('id', id)
    if (id) {
      this.form.originalWaybillId = id
      this.returnExchangeType = Number(type)
      this.getDetailInfo(id)
    }
    // 是否购买赔偿上限服务是:1, 否:0
    if (this.form.insured === 1) {
      this.rules.declaredValue = [RULES.required, RULES.declaredValue]
    }
  },
  deactivated() {
    console.log('deactivated')
  },
  destroyed() {
    console.log('destroyed')
  },
  computed: {
    ...mapGetters({
      userInfo: 'user'
    }),
    // 城市编号
    countryCode() {
      return this.$store.state.base.user.countryCode || ''
    },
    countryId() {
      return this.$store.state.base.user.countryId || ''
    },
    isReverse() {
      const { expressTypeCode } = this.form
      return expressTypeCode === 'Reverse' || expressTypeCode === `Reverse${this.countryCode}` || expressTypeCode === 'ReverseKW'
    }
  },
  watch: {
    /**
     * 监听寄件人省市
     * @param val
     */
    async 'form.senderProvinceId'(val) {
      const { data, code, msg } = await GET_AREA({ current: 1, size: 9999, type: 3, parentId: val })
      if (code === RESPONSE_SUCCESS) {
        this.cityList = data
        this.form.senderProvinceId = val
        // this.form.senderCityId = this.form.senderCityId
        // this.form.senderCityName = data[0].nativeName
        let obj = {}
        obj = this.provinceArray.find((item) => item.id === val)
        this.form.senderProvinceName = obj.nativeName
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * 监听收件人省市
     * @param val
     */
    async 'form.receiverProvinceId'(val) {
      const { data, code, msg } = await GET_AREA({ current: 1, size: 9999, type: 3, parentId: val })
      if (code === RESPONSE_SUCCESS) {
        this.cityList2 = data
        this.form.receiverProvinceId = val
        // this.form.receiverCityId = data[0].id
        // this.form.receiverCityName = data[0].nativeName
        let obj = {}
        obj = this.provinceArray.find((item) => item.id === val)
        this.form.receiverProvinceName = obj.nativeName
      } else {
        this.$message.error(msg)
      }
    },
    countryCode: {
      handler(val) {
        if (val === 'UAE') {
          // 阿联酋的用户行政区域要变
          this.senderProvinceName = this.$lang('寄件酋长国')
          this.senderCityName = this.$lang('寄件区域')
          this.receiverProvinceName = this.$lang('收件酋长国')
          this.receiverCityName = this.$lang('收件区域')
        }
        this.form.expressTypeName = 'Reverse'
        if (val === 'KSA') {
          this.form.expressTypeCode = 'Reverse'
        } if (val === 'KWT') {
          this.form.expressTypeCode = `ReverseKW`
        } else {
          this.form.expressTypeCode = `Reverse${this.countryCode}`
        }
      },
      immediate: true,
    },
    /**
     * 监听物品类型
     * @param val
     * @returns {Promise<void>}
     */
    async 'form.goods'(val) {
      const { id: goodsTypeId, code: goodsTypeCode, name: goodsTypeName } = val
      Object.assign(this.form, { goodsTypeId, goodsTypeCode, goodsTypeName })
      const { declaredValue, goods, insured, expressTypeCode } = this.form
      if (insured === 1 && goods && parseFloat(declaredValue) > 0 && expressTypeCode) {
        const res = await this.getComputationCost(this.form)
        Object.assign(this.form, { insuredValue: res })
      } else {
        this.form.insuredValue = 0
      }
      if (goodsTypeName === '文件') {
        Object.assign(this.form, { insured: 0, declaredValue: '' })
        this.form.insuredValue = 0
      }
    },
    /**
     * 监听结算方式
     * @param val
     * @returns {Promise<void>}
     */
    async 'form.payment'(val) {
      const { id: paymentModeId, code: paymentModeCode, name: paymentModeName } = val
      if (val.code === 'PP_CASH') {
        this.paidOption = false
      } else {
        this.paidOption = true
        this.form.paidMode = ''
      }
      Object.assign(this.form, { paymentModeId, paymentModeCode, paymentModeName })
      const { senderProvince, receiverProvince, packageTotalWeight } = this.form
      if (senderProvince && receiverProvince && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.form)
        Object.assign(this.form, res)
      }
      // 到付现结不支持赔偿上限服务
      if (val.name === '到付现结') {
        Object.assign(this.form, { insured: 0, declaredValue: '', signReceipt: 0 })
        this.form.insuredValue = 0
        this.form.receiptFreight = 0
      }
      console.log(this.form)
    },
    /**
     * 监听支付方式
     * @param val
     * @returns {Promise<void>}
     */
    async 'form.paidMode'(val) {
      const { id: paidModeId, code: paidModeCode, name: paidModeName } = val
      Object.assign(this.form, { paidModeId, paidModeCode, paidModeName })
      const { senderProvince, receiverProvince, packageTotalWeight } = this.form
      if (senderProvince && receiverProvince && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.form)
        Object.assign(this.form, res)
      }
      console.log(this.form)
    },
    /**
     * 运费计算
     * @param val
     * @returns {Promise<void>}
     */
    async 'form.senderCityName'(val) {
      const { receiverCityName, packageTotalWeight } = this.form
      if (receiverCityName && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.form)
        Object.assign(this.form, res)
      }
    },
    /**
     * 运费计算
     * @param val
     * @returns {Promise<void>}
     */
    async 'form.receiverCityName'(val) {
      const { senderCityName, packageTotalWeight } = this.form
      if (senderCityName && val && packageTotalWeight > 0) {
        const res = await this.calcStandardCost(this.form)
        Object.assign(this.form, res)
      }
    },
    /**
     * 运费重量
     * @param val
     * @returns {Promise<void>}
     */
    async 'form.packageTotalWeight'(val) {
      const { senderCityName, receiverCityName } = this.form
      if (senderCityName && receiverCityName && val > 0) {
        const res = await this.calcStandardCost(this.form)
        Object.assign(this.form, res)
      }
    },
    /**
     * 箱材规格计算
     * @param val
     * @returns {Promise<void>}
     */
    async 'form.boxStandard'(val) {
      const { id: boxStandardId, name: boxStandardName, salesPrice: boxPrice } = val
      const res = await this.calcBoxStandard({ boxStandardId, boxStandardName, boxPrice })
      Object.assign(this.form, res, {
        // 箱材规格id
        boxStandardId,
        // 箱材规格名称
        boxStandardName,
        // 箱材单价
        boxPrice,
      })
    },
    /**
     * 箱材数量
     * @param val
     * @returns {Promise<void>}
     */
    async 'form.boxNumber'(val) {
      const { boxStandardId, boxStandardName, boxPrice } = this.form
      const res = await this.calcBoxStandard({ boxStandardId, boxStandardName, boxPrice })
      Object.assign(this.form, res)
    },
    /**
     * 赔偿上限服务费计算
     * @param val
     * @returns {Promise<void>}
     */
    async 'form.declaredValue'(val) {
      const { goods, insured, expressTypeCode } = this.form
      if (insured === 1 && goods && parseFloat(val) > 0 && expressTypeCode) {
        const res = await this.getComputationCost(this.form)
        Object.assign(this.form, { insuredValue: res })
      } else {
        this.form.insuredValue = 0
      }
    },
    /**
     * 代收货款手续费计算
     * @param val
     * @returns {Promise<void>}
     */
    async 'form.codMoney'(val) {
      const { codMoney } = this.form
      const { decimalPoint } = this.userInfo // 货币小数位数
      if (parseFloat(codMoney) > 0) {
        if (parseFloat(codMoney) > this.codNumber) {
          this.$message.error(this.$lang('代收货款金额超额，最高限额为') + this.codNumber)
          this.form.codMoney = ''
          this.form.codFee = ''
          return
        } else if (codMoney.indexOf('.') !== -1 && codMoney.split('.').length > 2) {
          this.$message.error(this.$lang('代收货款不能有多个小数点！请重新输入'))
          this.form.codMoney = ''
          this.form.codFee = ''
          return
        } else if (codMoney.indexOf('.') !== -1 && codMoney.split('.')[1].length > (decimalPoint || 6)) {
          this.$message.error(`${this.$lang('代收货款不能超过')} ${decimalPoint || 6} ${this.$lang('位小数！请重新输入')}`)
          this.form.codMoney = ''
          this.form.codFee = ''
          return
        }
        const codFeeParam = { collectionfee: codMoney }
        const res = await getCalc(codFeeParam)
        Object.assign(this.form, { codFee: (res.data !== undefined && res.data !== null ? res.data : 0) })
      } else {
        this.form.codMoney = ''
        this.form.codFee = ''
      }
    },
  },
  methods: {
    async judgeShortAddress(e, type, prop) {
      try {
        const { value } = e.target
        if (value) {
          const regex = /^[A-Za-z]{4}\d{4}$/
          if (!regex.test(value)) {
            this.form[prop] = ''
            this.$message.error(this.$lang('不符合短地址规则'))
            return
          }
          const { code, data } = await judgeShortAddress({ shortAddress: value })
          if (code === RESPONSE_SUCCESS && data && data === true) {
            this.getShortAddress(e, type)
          } else {
            this[type] = ''
            this.form[prop] = ''
            this.$message.error(this.$lang('未找到该短地址对应的地址，请核实后重试。'))
          }
        } else {
          this[type] = ''
          this.form[prop] = ''
        }
      } catch (error) {
        this[type] = ''
      }
    },
    async getShortAddress(e, type) {
      try {
        const { value } = e.target
        if (value) {
          const { code, data, msg } = await getShortAddress({ shortAddress: value })
          if (code === RESPONSE_SUCCESS) {
            this[type] = data || ''
          } else {
            this[type] = ''
            this.$message.error(msg)
          }
        } else {
          this[type] = ''
        }
      } catch (error) {
        this[type] = ''
      }
    },
    ...mapActions(['UPDATE_PRINT_STOCK']),
    /**
     * 获取基础数据
     * @returns {Promise<void>}
     */
    async getBaseDataList() {
      const { data, code, msg } = await getList()
      if (code === RESPONSE_SUCCESS) {
        this.prodectData = data['appProductTypeVOList']
        console.log('获取基础数据', this.prodectData)
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * 获取酋长国数据
     * @returns {Promise<void>}
     */
    async getProList() {
      const { data, code, msg } = await GET_AREA({ current: 1, size: 9999, type: 2 })
      if (code === RESPONSE_SUCCESS) {
        this.provinceArray = data
        console.log(this.provinceArray)
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * 获取币别  sysCurrencyType/list
     * @returns {Promise<void>}
     */
    async getCurrencyTypeList() {
      const { data, code, msg } = await getsysCurrencyType()
      const dataList = []
      if (code === RESPONSE_SUCCESS) {
        for (let p = 0; p < data.length; p++) {
          dataList.push({ codCurrencyTypeCode: data[p].coding, codCurrencyTypeName: data[p].name })
        }
        this.codCurrencyType = dataList
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * 获取详情信息
     * @param id
     * @returns {Promise<void>}
     */
    async getDetailInfo(id) {
      this.isLoadingPage = true
      const { data, code, msg } = await fetchExchangeDetail({
        from: 'vip',
        id: id,
        // 1:订单号; 2:运单号
        idType: 2,
        needOrderMember: true,
        needOrderExt: true
      })
      if (code === RESPONSE_SUCCESS) {
        // 寄件人信息与收件人信息互换
        const obj = {
          // 寄件人
          senderName: data.receiverName,
          senderMobilePhone: data.receiverMobilePhone,
          senderCompany: data.receiverCompany,
          senderPostalCode: data.receiverPostalCode,
          senderEmail: data.receiverEmail,
          senderProvinceId: data.receiverProvinceId,
          senderProvinceName: data.receiverProvinceName,
          senderCityId: data.receiverCityId,
          senderCityName: data.receiverCityName,
          senderAreaId: data.receiverAreaId,
          senderAreaName: data.receiverAreaName,
          senderStreet: data.receiverStreet,
          senderDetailedAddress: data.receiverDetailedAddress,
          // 收件人
          receiverName: data.senderName,
          receiverMobilePhone: data.senderMobilePhone,
          receiverCompany: data.senderCompany,
          receiverPostalCode: data.senderPostalCode,
          receiverEmail: data.senderEmail,
          receiverProvinceId: data.senderProvinceId,
          receiverProvinceName: data.senderProvinceName,
          receiverCityId: data.senderCityId,
          receiverCityName: data.senderCityName,
          receiverAreaId: data.senderAreaId,
          receiverAreaName: data.senderAreaName,
          receiverStreet: data.senderStreet,
          receiverDetailedAddress: data.senderDetailedAddress,
          goods: { id: data.goodsTypeId, name: data.goodsTypeName, code: data.goodsTypeCode },
          payment: { code: 'PP_PM', name: this.$lang('Monthly'), id: 42 },
          expressTypeCode: this.countryCode === 'KSA' ? 'Reverse' : this.countryCode === 'KWT' ? 'ReverseKW' : `Reverse${this.countryCode}`, // 产品类型code
          expressTypeName: 'Reverse', // 产品类型name
          taxation: 15 // 税率
        }
        if (this.countryId === 1) {
          if (obj.senderCityId) {
            await this.getAreaInfo(obj.senderCityId, 1)
          }
          if (obj.receiverCityId) {
            await this.getAreaInfo(obj.receiverCityId, 2)
          }
        }
        this.form = Object.assign(this.form, Object.assign(data, obj))
        console.log('form', this.form)
        // Reverse 禁用报价费勾选
        if (this.isReverse) {
          this.codFlag = false
          this.codIsInput = true
          this.form.codCurrencyTypeName = ''
          this.form.codCurrencyTypeCode = ''
          this.form.codMoney = ''
          this.form.codFee = ''
        }
        const res = await waybillPlaintext({ waybillNo: id, type: 1 })
        if (res.code === RESPONSE_SUCCESS) {
          this.form = { ...this.form, ...res.data }
        }

        const resReceiving = await waybillPlaintext({ waybillNo: id, type: 2 })
        if (resReceiving.code === RESPONSE_SUCCESS) {
          this.form = { ...this.form, ...resReceiving.data }
        }
      } else {
        this.$message.error(msg)
      }
      this.isLoadingPage = false
    },
    /**
     * 地址簿选择弹窗功能
     * @param data
     * @param type
     */
    singleRowSelect(data, type) {
      if (!data.cityId) {
        return
      }
      const { name, mobile, detailedAddress, companyName, reserveMobile } = data
      if (type === 1) { // 1寄件2取件
        this.form.senderName = name // 寄件人姓名,
        this.form.senderMobilePhone = this.filterPhone(mobile) // 寄件人手机号
        this.form.senderDetailedAddress = detailedAddress // 寄件详细地址
        this.form.senderCompany = companyName
        this.curentSend = data
        this.setProvince(data, type)
      } else if (type === 2) {
        this.form.receiverName = name // 收件人姓名,
        this.form.receiverMobilePhone = this.filterPhone(mobile) // 收件人手机号
        this.form.receiverTelphone = this.filterPhone(reserveMobile) // 收件人备用手机号
        this.form.receiverDetailedAddress = detailedAddress // 收件详细地址
        this.form.receiverCompany = companyName
        this.curentReceiver = data
        this.setProvince(data, type)
      }
    },
    /**
     * 获取默认地址薄
     * @param param
     * @returns {Promise<void>}
     */
    async getDefaultAddress(param) {
      const { code, msg, data } = await getDefaultAddress(param)
      if (code === RESPONSE_SUCCESS) {
        if (data) {
          this.singleRowSelect(data, param.type)
        }
      } else {
        this.$message.error(this.$lang(msg))
      }
    },
    /**
     * 获取地址薄信息
     * @param params
     * @param queryString
     * @param cb
     * @returns {Promise<void>}
     */
    async getAddressList(params, queryString, cb) {
      const { data, msg, code } = await reqAddressList(params)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString ? diseaseList.filter(item => item['name'].toLowerCase().indexOf(queryString.toLowerCase()) !== -1) : diseaseList
        // 调用 callback 返回建议列表的数据
        cb(results)
      } else {
        cb([])
        this.$message.error(this.$lang(msg))
        this.loading = false
      }
    },
    /**
     * 发件人模糊远程搜索
     * @param queryString
     * @param cb
     * @returns {Promise<void>}
     */
    async remoteSenderName(queryString, cb) {
      this.loading = true
      const params = {
        current: 1,
        size: 100,
        type: 1,
        keyword: queryString,
      }
      await this.getAddressList(params, queryString, cb)
    },
    /**
     * 收件人姓名模糊搜索
     * @param queryString
     * @param cb
     * @returns {Promise<void>}
     */
    async remoteReceiverName(queryString, cb) {
      this.loading = true
      const params = {
        current: 1,
        size: 100,
        type: 2,
        keyword: queryString,
      }
      await this.getAddressList(params, queryString, cb)
    },
    /**
     * 打开地址薄
     * @param selectType
     */
    openAddress(selectType) {
      this.addrBook = true
      this.selectType = selectType
      const data = selectType === 1 ? this.curentSend : this.curentReceiver
      this.$refs.address.updateBtnStauts(data)
      this.$refs.address.initData()
    },
    /**
     * 监听寄件人姓名或者电话改变
     * @param item
     */
    onChangeSenderName(item) {
      this.form.senderName = item.name
      this.form.senderMobilePhone = this.filterPhone(item.mobile)
      this.form.senderCompany = item.companyName
      this.form.senderDetailedAddress = item.detailedAddress
      this.setProvince(item, 1)
    },
    /**
     * 监听收件人姓名或者电话改变
     * @param item
     */
    onChangeReceiverName(item) {
      this.form.receiverName = item.name
      this.form.receiverMobilePhone = this.filterPhone(item.mobile)
      this.form.receiverTelphone = this.filterPhone(item.reserveMobile)
      this.form.receiverCompany = item.companyName
      this.form.receiverDetailedAddress = item.detailedAddress
      this.setProvince(item, 2)
    },
    /**
     * 寄件/收货的城市重新赋值
     * onChangeSenderName/onChangeReceiverName方法使用
     * @param row
     * @param type
     */
    async setProvince(row, type) {
      const { cityId, cityName, provinceId, provinceName, areaName, areaId, street } = row
      if (type === 1) {
        this.form.senderProvinceId = provinceId
        this.form.senderProvinceName = provinceName
        await this.getCityInfo(provinceId, 1)
        this.form.senderCityId = cityId
        this.form.senderCityName = cityName
        this.form.senderStreet = street
        if (this.countryId === 1) {
          await this.getAreaInfo(cityId, 1)
          this.form.senderAreaId = areaId
          this.form.senderAreaName = areaName
        }
      } else {
        this.form.receiverProvinceId = provinceId
        this.form.receiverProvinceName = provinceName
        await this.getCityInfo(provinceId)
        this.form.receiverCityId = cityId
        this.form.receiverCityName = cityName
        this.form.receiverStreet = street
        if (this.countryId === 1) {
          await this.getAreaInfo(cityId, 2)
          this.form.receiverAreaId = areaId
          this.form.receiverAreaName = areaName
        }
      }
    },
    /**
     * 监听寄件/收货的省份切换获取城市列表
     * @param pid 省份id
     * @param type 寄件人
     */
    async onProvinceChange(pid, type) {
      const { data, code, msg } = await GET_AREA({ current: 1, size: 9999, type: 3, parentId: pid })
      if (code === RESPONSE_SUCCESS) {
        if (type === 1) {
          this.cityList = data
          this.form.senderProvinceId = pid
          this.form.senderCityId = data[0].id
          this.form.senderCityName = data[0].nativeName
          let obj = {}
          obj = this.provinceArray.find((item) => item.id === pid)
          this.form.senderProvinceName = obj.nativeName
        } else {
          this.cityList2 = data
          this.form.receiverProvinceId = pid
          this.form.receiverCityId = data[0].id
          this.form.receiverCityName = data[0].nativeName
          let obj = {}
          obj = this.provinceArray.find((item) => item.id === pid)
          this.form.receiverProvinceName = obj.nativeName
        }
        this.getAreaInfo(data[0].id, type)
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * 监听寄件/收货的城市切换
     * @param value
     * @param num
     */
    onCityChange(value, num) {
      if (num === 1) {
        this.form.senderCityId = value
        const obj = this.cityList.find((item) => {
          return item.id === value
        })
        this.form.senderCityName = obj.nativeName
      } else {
        this.form.receiverCityId = value
        const obj = this.cityList2.find((item) => item.id === value)
        this.form.receiverCityName = obj.nativeName
      }
      if (this.countryId === 1) {
        if (num === 1) {
          this.areaList = []
          this.form.senderAreaName = ''
          this.form.senderAreaId = ''
        } else {
          this.areaList2 = []
          this.form.receiverAreaName = ''
          this.form.receiverAreaId = ''
        }
        this.getAreaInfo(value, num)
      }
    },
    onAreaChange(value, num) {
      if (num === 1) {
        this.form.senderAreaId = value
        const obj = this.areaList.find((item) => {
          return item.id === value
        })
        this.form.senderAreaName = obj.nativeName
      } else {
        this.form.receiverAreaId = value
        const obj = this.areaList2.find((item) => item.id === value)
        this.form.receiverAreaName = obj.nativeName
      }
    },
    /**
     * 查询城市数据
     * @param provinceId
     * @param flagType
     * @returns {Promise<void>}
     */
    async getCityInfo(provinceId, flagType) {
      const { data, code, msg } = await GET_AREA({ current: 1, size: 9999, type: 3, parentId: provinceId })
      if (code === RESPONSE_SUCCESS) {
        if (flagType === 1) {
          this.cityList = data
        } else {
          this.cityList2 = data
        }
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * 查询区域数据
     * @param {*} provinceId
     * @param {*} flagType
     */
    async getAreaInfo(provinceId, flagType) {
      const { data, code, msg } = await GET_AREANEW({ current: 1, size: 9999, type: 4, parentId: provinceId })
      if (code === RESPONSE_SUCCESS) {
        if (flagType === 1) {
          this.areaList = data
        } else {
          this.areaList2 = data
        }
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * 过滤手机号
     * @param val
     * @returns {string|*}
     */
    filterPhone(val) {
      if (!val) return ''
      if (val.includes('+86') || val.includes('+966')) return val
      if (val.length === 11) return `+86-${val}`
      if (val.length === 9) return `+966-${val}`
      return val
    },
    /**
     * 运费计算
     * @param data
     * @returns {Promise<{}>}
     */
    async calcStandardCost(data) {
      const { senderProvinceId, senderCityId, receiverCityId, receiverProvinceId, packageTotalWeight, paymentModeId, expressTypeCode } = this.form
      const promises = [
        // 获取起始地址ID
        this.getSettlement(senderProvinceId, senderCityId),
        // 获取目的地地址ID
        this.getSettlement(receiverProvinceId, receiverCityId),
      ]
      const [startAddressId, endAddressId] = await Promise.all(promises)
      // 运费
      const obj = {}
      // 如果起始地址且目的地地址ID存在
      if (startAddressId && endAddressId && expressTypeCode) {
        // 获取运费
        const res = await this.getComCost(packageTotalWeight, startAddressId, endAddressId, paymentModeId, expressTypeCode)
        obj.standardValue = res.cost
        obj.settlementWeight = res.setWeight
      }
      // 返回结果
      return {
        ...obj,
      }
    },
    /**
     * 通过省市区匹配结算目的地(目的区域)
     * @param providerId
     * @param cityId
     * @param packageTotalWeight
     * @param type
     * @returns {Promise<string|*>}
     */
    async getSettlement(providerId, cityId, packageTotalWeight, type) {
      const reqData = { providerId, cityId }
      const { code, data } = await getSettlement(reqData)
      if (code === RESPONSE_SUCCESS && data) {
        return data.id
      } else {
        return ''
      }
    },
    /**
     * 获取运费
     * @param number
     * @param startAddressId
     * @param endAddressId
     * @param paymentModeId
     * @param productTypeCode
     * @returns {Promise<number>}
     */
    async getComCost(number, startAddressId, endAddressId, paymentModeId, productTypeCode) {
      let smModeType = 2
      if (paymentModeId) {
        switch (paymentModeId) {
          case 320:
            smModeType = 1
            break
          case 319:
            smModeType = 2
            break
          case 321:
            smModeType = 3
            break
        }
      }
      // 服务方式-serviceMethodCode 写死寄件上门 01
      const reqData = { startAddressId, endAddressId, number, productTypeCode, serviceMethodCode: '01', ...{ smMode: smModeType }}
      const { data = 0 } = await getComCost(reqData)
      return data || 0
    },
    /**
     * 箱材规格计算
     * @param boxStandardId
     * @param boxStandardName
     * @param boxPrice
     * @returns {Promise<{boxTotalPrice: *}>}
     */
    async calcBoxStandard({ boxStandardId, boxStandardName, boxPrice } = {}) {
      const { boxNumber } = this.form
      // 箱数量
      const boxTotalPrice = this.$common.floatNumSub(boxNumber ? boxNumber * boxPrice : 0)
      return {
        // 箱材总价格
        boxTotalPrice,
      }
    },
    /**
     * 是否代收货款
     * @param val
     * @returns {Promise<void>}
     */
    async checkCod(val) {
      if (val) {
        const res = await customerCod({ customerCode: this.userInfo.customerCode })
        if (res !== undefined && res.data !== null && res.data.isOpenCod === 1) {
          if (this.countryCode === 'UAE') {
            this.form.codCurrencyTypeName = 'AED' // 代收货款币别
            this.form.codCurrencyTypeCode = 'AED' // 代收货款币别code
          } else {
            this.form.codCurrencyTypeName = 'SAR' // 代收货款币别
            this.form.codCurrencyTypeCode = 'SAR' // 代收货款币别code
          }
          this.codNumber = res.data.maxCollectionMoney
          this.codIsInput = false
        } else {
          this.$message.error(this.$lang('您未开通代收货款服务，请联系合作网点！'))
          this.codFlag = false
        }
      } else {
        this.form.codCurrencyTypeName = '' // 代收货款币别
        this.form.codCurrencyTypeCode = '' // 代收货款币别code
        this.codIsInput = true
      }
    },
    /**
     * 是否购买赔偿上限服务
     * @param val
     */
    changeInsured(val) {
      this.form.insured = val
      if (val === 0) {
        this.form.declaredValue = ''
        this.form.insuredValue = 0
      }
    },
    /**
     * 赔偿上限服务费计算
     * @param param
     * @returns {Promise<*|number>}
     */
    async getComputationCost(param) {
      // 参数
      const params = {
        // 物品价值
        value: param.declaredValue,
        // 物品类型code
        goodsTypeCode: param.goods.code,
        productTypeCode: param.expressTypeCode
      }
      // 调用接口
      const { data } = await getComputationCost(params)
      return data || 0
    },
    /**
     * 上传
     * @param res
     * @param file
     */
    async uploadSuccess({ res, file }) {
      console.log('res', res)
      console.log('file', file)
      this.imageList.push(res)
      const paths = this.imageList.map(item => item.path)
      this.form.productSkuImageUrl = paths.toString()
    },
    /**
     * 图片删除
     */
    uploadRemove(index, fileList) {
      this.imageList = fileList.filter((item, i) => i !== index)
    },
    /**
     * 提交数据校验
     * @param formName
     * @returns {Promise<void>}
     */
    async saveSubmitValidate(formName) {
      console.log(this.form)
      if (this.form.paymentModeId === 321 && this.form.insured !== 0) {
        this.$message.error(this.$lang('到付件不支持赔偿上限服务'))
        return
      }
      if (this.form.insured === 1 && (!this.form.declaredValue || parseFloat(this.form.declaredValue) <= 0)) {
        this.$message.error(this.$lang('货物价值必须大于0'))
        return
      }
      this.isSubmitLoading = true
      this.codCurrencyType.map((item) => {
        if (this.form.codCurrencyTypeName === item.codCurrencyTypeName) {
          this.form.codCurrencyTypeCode = item.codCurrencyTypeCode
        }
      })
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.form.insured === 0) {
            this.form.declaredValue = ''
          }
          this.form.packageChargeWeight = this.form.packageTotalWeight
          this.form.boxStandardCode = this.form.boxStandard ? this.form.boxStandard.code : ''
          this.form.boxNumber = this.form.boxStandard ? this.form.boxNumber : null
          this.form.checkReceiverFlag = this.checkReceiverFlag ? 1 : 0
          this.form.checkSenderFlag = this.checkSenderFlag ? 1 : 0
          this.form.needDispatch = this.userInfo.scheduleType
          this.form.isUnpackEnabled = this.form.isUnpackEnabled ? 1 : 0
          this.imageList = []
          console.log(this.form)
          if (this.returnExchangeType === 1) {
            // 退货直接提交订单
            await this.saveOrder(this.form)
          } else if (this.returnExchangeType === 2) {
            // 退换货需要跳转到换货页面,保存退货页面数据
            this.$store.dispatch('returnOrder/setForm', this.form).then(res => {
              this.$router.push({
                path: `/submitExchange/${this.form.originalWaybillId}/2`,
              })
            }).catch(err => {
              this.$message.error(err)
            })
          } else {
            this.$message.error('退换货类型错误')
          }
          this.isSubmitLoading = false
        } else {
          this.isSubmitLoading = false
          return false
        }
      })
    },
    /**
     * 数据提交
     * @param params
     * @returns {Promise<void>}
     */
    async saveOrder(params) {
      try {
        const { code, data, msg } = await fetchCreateReturnOrder(params)
        if (code === RESPONSE_SUCCESS) {
          this.getOrderId = data.id
          this.$message({
            message: this.$lang('下单成功！'),
            type: 'success',
          })

          this.$refs.sizeForm.resetFields()
          this.checkSenderFlag = false
          this.checkReceiverFlag = false
          this.codFlag = false
          this.codIsInput = true
          this.form.senderPostalCode = ''
          this.form.senderEmail = ''
          this.form.receiverPostalCode = ''
          this.form.receiverEmail = ''
        } else if (code === 149010023) {
          this.$message.warning(msg)
          this.form.senderProvinceId = ''// 收件省份id
          this.form.senderProvinceName = ''// 收件省份名称
          this.form.senderCityId = ''// 收件城市id
          this.form.senderCityName = ''// 收件城市名称
          this.form.senderAreaId = '' // 收件区域id
          this.form.senderAreaName = '' // 收件区域id
          this.form.senderStreet = '' // 收件区域名称
          this.form.senderProvince = '' // 收件区省/市/区
          this.form.senderProvince = ''
        } else if (code === 149010024) {
          this.$message.warning(msg)
          this.form.receiverProvinceId = ''// 收件省份id,
          this.form.receiverProvinceName = ''// 收件省份名称,
          this.form.receiverCityId = ''// 收件城市id,
          this.form.receiverCityName = ''// 收件城市名称,
          this.form.receiverAreaId = '' // 收件区域id,
          this.form.receiverAreaName = '' // 收件区域id,
          this.form.receiverStreet = '' // 收件区域名称,
          this.form.receiverProvince = '' // 收件区省/市/区
        } else {
          this.$message.error(msg)
        }
        this.isSubmitLoading = false
      } catch (err) {
        this.isSubmitLoading = false
        this.$message.error(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#SubmitReturnsExchange {
  .page-container {
    padding: 16px 24px;
    box-sizing: border-box;
  }

  .order-code {
    color: #e60012;
    padding: 10px 10px;
    background-color: #edeef3;
  }

  .label {
    margin-top: 22px;
  }

  .group-container {
    background-color: #f7f7f9;
    padding: 20px 20px 0;
    border-radius: 8px;
  }

  .el-form-item {
    padding: 0 8px 24px 8px;
  }

  .form-address {
    width: 100%;

    .el-input {
      width: 360px !important;
    }
  }
}
</style>
